<template>
  <el-form-item label="onDisableOperationButton" title="onDisableOperationButton" label-width="150px">
    <el-button type="info" icon="el-icon-edit" plain round :class="[eventHandled ? 'button-text-highlight' : '']"
               @click="editEventHandler('onDisableOperationButton', eventParams)">
      {{i18nt('designer.setting.addEventHandler')}}</el-button>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"
  import eventMixin from "./eventMixin"

  export default {
    name: "onDisableOperationButton-editor",
    mixins: [i18n, eventMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
      eventHandled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        eventParams: ['buttonConfig', 'rowIndex', 'row'],
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// onDisableOperationButton-editor.vue?1e7fc9ca